import { render, staticRenderFns } from "./Repos.vue?vue&type=template&id=4061499e&scoped=true"
import script from "./Repos.vue?vue&type=script&lang=js"
export * from "./Repos.vue?vue&type=script&lang=js"
import style0 from "./Repos.vue?vue&type=style&index=0&id=4061499e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061499e",
  null
  
)

export default component.exports